// etoo brand mark — a clean geometric lowercase "e" on a violet gradient tile.
export function EtooMark({ size = 24 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true">
      <defs>
        <linearGradient id="etoo-mark-bg-scr" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#8b5cf6" />
          <stop offset="100%" stopColor="#a78bfa" />
        </linearGradient>
        <linearGradient id="etoo-mark-hl-scr" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="rgba(255,255,255,0.35)" />
          <stop offset="100%" stopColor="rgba(255,255,255,0)" />
        </linearGradient>
      </defs>
      {/* Rounded-square badge with a soft rim */}
      <rect x="1" y="1" width="30" height="30" rx="6" fill="url(#etoo-mark-bg-scr)" />
      <rect x="1" y="1" width="30" height="30" rx="6" fill="none" stroke="rgba(255,255,255,0.28)" strokeWidth="1.2" />
      <rect x="5" y="5" width="22" height="22" rx="4.5" fill="none" stroke="rgba(255,255,255,0.18)" strokeWidth="0.8" />
      <rect x="1" y="1" width="30" height="30" rx="6" fill="url(#etoo-mark-hl-scr)" />
      {/* The "e" */}
      <g fill="none" stroke="#ffffff" strokeWidth="2.4" strokeLinecap="round">
        <path d="M22.6 14 C22.1 11.7 19.5 10.5 16.2 10.5 C12.8 10.5 10.7 13 10.7 16.5 C10.7 20 12.8 22.5 16.2 22.5 C19.5 22.5 22.1 21.3 22.6 19" />
        <line x1="11.5" y1="16.5" x2="24.2" y2="16.5" />
      </g>
    </svg>
  );
}

// Fixed top-left badge linking back to the etoo game hub (/ = landing page).
export function EtooLogo() {
  return (
    <a
      href="/"
      title="etoo — all games"
      aria-label="etoo — all games"
      className="group fixed top-3 left-3 z-40 flex items-center gap-1.5 rounded-xl border border-scr-border bg-white/90 pl-1 pr-2.5 py-1 shadow-sm backdrop-blur-sm transition-all duration-200 hover:-translate-y-0.5 hover:border-scr-accent/40 hover:shadow-md"
    >
      <EtooMark size={26} />
      <span className="font-display text-sm font-bold tracking-tight text-scr-ink">etoo</span>
    </a>
  );
}